export default {"src":"/_next/static/media/none.ad07e26c.svg","height":40,"width":41};